(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/endpoints/search-api.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/endpoints/search-api.js');
"use strict";

const {
  jupiterFetch
} = svs.core;
const svsFetch = svs.core.svsFetch.create();
const casinoMicroserviceSocket = svs.core.svsSocket.get('/v1/casino-socket');
const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
const {
  fetchBaseQuery,
  createApi
} = RTKQ;
const {
  constants: {
    CardType
  },
  utils: {
    normalizeCardData
  }
} = svs.components.casino_react.common;

function serializeWithoutPaging(endpointName) {
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    searchQuery,
    tags,
    categories,
    providers,
    sorting,
    listIds,
    listId
  } = args;
  const params = new URLSearchParams();
  params.append('endpoint', endpointName);
  if (searchQuery) {
    params.append('query', searchQuery);
  }
  if (tags !== null && tags !== void 0 && tags.length) {
    params.append('tags', tags.join(','));
  }
  if (categories !== null && categories !== void 0 && categories.length) {
    params.append('categories', categories.join(','));
  }
  if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
    const [orderBy, sortOrder] = sorting.split('-');
    if (orderBy !== 'default') {
      params.append('orderBy', encodeURIComponent(orderBy));
      params.append('sortOrder', encodeURIComponent(sortOrder));
    }
  }
  if (providers !== null && providers !== void 0 && providers.length) {
    params.append('providers', providers.join(','));
  }
  if (listIds !== null && listIds !== void 0 && listIds.length) {
    params.append('listIds', listIds.join(','));
  }
  if (listId) {
    params.append('listId', listId);
  }
  return params.toString();
}
const getSearchResult = 'getSearchResult';
const getListFilterResult = 'getListFilterResult';
const searchApi = createApi({
  reducerPath: 'SearchAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: jupiterFetch.url(),
    fetchFn: jupiterFetch.fetch
  }),
  endpoints: builder => ({
    [getListFilterResult]: builder.query({
      queryFn: async (_ref, _api, _extraOptions, baseQuery) => {
        let {
          listId = '',
          count = 1000,
          offset = 0
        } = _ref;
        const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
        if (useLegacyJupiterApi) {
          const qs = new URLSearchParams();
          qs.append('count', encodeURIComponent(count));
          qs.append('offset', encodeURIComponent(offset));
          qs.append('listId', encodeURIComponent(listId));
          qs.append('routesDomain', encodeURIComponent('spela'));
          const result = await baseQuery("/content/2/listfilter?".concat(qs.toString()));
          if (result.error) {
            return result;
          }

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(result.data.result);
          return {
            data: {
              error: result.data.error,
              totalCount: result.data.totalCount,
              games: result.data.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        }

        try {
          const client = svs.content.shared.getCmsClient();
          const response = await client.v1.content.listFilter({
            listIds: listId,
            count,
            offset,
            channels: svs.core.data.capabilities.channel
          });

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(response.result);
          return {
            data: {
              error: null,
              totalCount: response.totalCount,
              games: response.result.map(game => normalizeCardData({
                name: game.name
              }, CardType.GAME))
            }
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      serializeQueryArgs: _ref2 => {
        let {
          endpointName,
          queryArgs
        } = _ref2;
        return serializeWithoutPaging(endpointName, queryArgs);
      },
      merge: (currentCache, _ref3) => {
        let {
          games,
          error,
          totalCount
        } = _ref3;
        if (!(currentCache !== null && currentCache !== void 0 && currentCache.games)) {
          currentCache.games = [];
        }
        currentCache.error = error;
        currentCache.totalCount = totalCount;
        const currentlyLoadedGamesList = new Set(currentCache.games.map(game => {
          var _game$model;
          return (_game$model = game.model) === null || _game$model === void 0 ? void 0 : _game$model.name;
        }));
        for (const game of games) {
          var _game$model2;
          if (!currentlyLoadedGamesList.has((_game$model2 = game.model) === null || _game$model2 === void 0 ? void 0 : _game$model2.name)) {
            currentCache.games.push(game);
          }
        }
      },
      forceRefetch(_ref4) {
        let {
          currentArg,
          previousArg
        } = _ref4;
        const cur = serializeWithoutPaging(getListFilterResult, currentArg);
        const prev = serializeWithoutPaging(getListFilterResult, previousArg);
        return cur !== prev;
      }
    }),
    [getSearchResult]: builder.query({
      queryFn: async (_ref5, _api, _extraOptions, baseQuery) => {
        let {
          searchQuery = '',
          categories = [],
          listIds = [],
          providers = [],
          tags = [],
          count = 1000,
          offset = 0,
          sorting = ''
        } = _ref5;
        const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
        if (useLegacyJupiterApi) {
          const qs = new URLSearchParams();
          qs.append('count', encodeURIComponent(count));
          qs.append('offset', encodeURIComponent(offset));
          if (typeof searchQuery === 'string' && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0) {
            qs.append('query', encodeURIComponent(searchQuery));
          }
          if (Array.isArray(categories) && (categories === null || categories === void 0 ? void 0 : categories.length) > 0) {
            qs.append('categories', categories.join(','));
          }
          if (Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0) {
            qs.append('providers', providers.join(','));
          }
          if (Array.isArray(listIds) && (listIds === null || listIds === void 0 ? void 0 : listIds.length) > 0) {
            qs.append('listIds', listIds.join(','));
          }
          if (Array.isArray(tags) && (tags === null || tags === void 0 ? void 0 : tags.length) > 0) {
            qs.append('tags', tags.join(','));
          }
          if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
            const [orderBy, sortOrder] = sorting.split('-');
            if (orderBy !== 'default') {
              qs.append('orderBy', encodeURIComponent(orderBy));
              qs.append('sortOrder', encodeURIComponent(sortOrder));
            }
          }
          qs.append('routesDomain', encodeURIComponent('spela'));
          const queryArray = [];
          qs.forEach((val, key) => {
            if (key === 'routesDomain') {
              queryArray.push("".concat(key, "=").concat(val));
            } else {
              queryArray.push("".concat(key, "=").concat(val, "&"));
            }
          });
          const result = await baseQuery("/content/4/casinosearch?".concat(queryArray.join('')));
          if (result.error) {
            return result;
          }

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(result.data.result);
          return {
            data: {
              error: result.data.error,
              totalCount: result.data.totalCount,
              games: result.data.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        }

        try {
          const client = svs.content.shared.getCmsClient();
          const sort = [];
          if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
            const [orderBy, sortOrder] = sorting.split('-');
            if (orderBy !== 'default') {
              sort.push("".concat(orderBy, ";").concat(sortOrder));
            }
          }
          const response = await client.v1.content.casinoSearch({
            query: typeof searchQuery === 'string' && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0 ? searchQuery : undefined,
            categories: Array.isArray(categories) && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 ? categories.join(',') : undefined,
            providers: Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? providers.join(',') : undefined,
            tags: Array.isArray(tags) && (tags === null || tags === void 0 ? void 0 : tags.length) > 0 ? tags.join(',') : undefined,
            listIds: Array.isArray(listIds) && (listIds === null || listIds === void 0 ? void 0 : listIds.length) > 0 ? listIds.join(',') : undefined,
            sort: sort.length > 0 ? sort : undefined,
            count,
            offset
          });

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(response.result);
          return {
            data: {
              error: null,
              totalCount: response.totalCount,
              games: response.result.map(game => normalizeCardData({
                name: game.name
              }, CardType.GAME))
            }
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      serializeQueryArgs: _ref6 => {
        let {
          endpointName,
          queryArgs
        } = _ref6;
        return serializeWithoutPaging(endpointName, queryArgs);
      },
      merge: (currentCache, _ref7) => {
        let {
          games,
          error,
          totalCount
        } = _ref7;
        if (!(currentCache !== null && currentCache !== void 0 && currentCache.games)) {
          currentCache.games = [];
        }
        currentCache.error = error;
        currentCache.totalCount = totalCount;
        const currentlyLoadedGamesList = new Set(currentCache.games.map(game => {
          var _game$model3;
          return (_game$model3 = game.model) === null || _game$model3 === void 0 ? void 0 : _game$model3.name;
        }));
        for (const game of games) {
          var _game$model4;
          if (!currentlyLoadedGamesList.has((_game$model4 = game.model) === null || _game$model4 === void 0 ? void 0 : _game$model4.name)) {
            currentCache.games.push(game);
          }
        }
      },
      forceRefetch(_ref8) {
        let {
          currentArg,
          previousArg
        } = _ref8;
        const cur = serializeWithoutPaging(getSearchResult, currentArg);
        const prev = serializeWithoutPaging(getSearchResult, previousArg);
        return cur !== prev;
      }
    }),
    getSocketLiveData: builder.query({
      queryFn: async (_ref9, _api, _extraOptions, baseQuery) => {
        let {
          liveTableId,
          clientStartType,
          provider
        } = _ref9;
        if (!useCloudCasinoApis) {
          const supplier = provider === 'OnAir' ? provider : clientStartType;
          const result = await baseQuery("/casino/1/gameinfo/livedata/".concat(liveTableId.toLowerCase(), "?supplier=").concat(supplier));
          if (result.error) {
            return result;
          }
          return {
            data: result.data
          };
        }
        try {
          const providerEndpoint = provider.replace(' ', '').replace('_', '').toLowerCase();
          const response = await svsFetch("/v1/casino/providers/".concat(providerEndpoint, "/tables/").concat(liveTableId.toLowerCase()));
          const data = await response.json();
          return {
            data
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(arg, _ref0) {
        let {
          updateCachedData,
          cacheDataLoaded,
          cacheEntryRemoved
        } = _ref0;
        const {
          liveTableId,
          clientStartType,
          provider
        } = arg;
        const handleUpdate = data => {
          if (!useCloudCasinoApis) {
            updateCachedData(() => data);
            return;
          }
          updateCachedData(() => {
            var _data$message;
            return data === null || data === void 0 || (_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.data;
          });
        };
        let subscription;
        let socketUrl;
        if (!useCloudCasinoApis) {
          const supplier = provider === 'OnAir' ? provider : clientStartType;
          socketUrl = "/casino/1/gameinfo/livedata/".concat(liveTableId.toLowerCase(), "?supplier=").concat(supplier);
        } else {
          const providerEndpoint = provider.replace(' ', '').replace('_', '').toLowerCase();
          socketUrl = "/api/v1/casino/providers/".concat(providerEndpoint, "/tables/").concat(liveTableId.toLowerCase());
        }
        try {
          await cacheDataLoaded; 
          if (!useCloudCasinoApis) {
            svs.core.socket.subscribe(socketUrl, handleUpdate, {}, false, true, false);
          } else {
            subscription = casinoMicroserviceSocket.subscribe(socketUrl, handleUpdate);
          }
        } catch (_unused) {
        }
        await cacheEntryRemoved;
        if (!useCloudCasinoApis) {
          svs.core.socket.unsubscribe(socketUrl, handleUpdate);
        } else if (subscription) {
          subscription.unsubscribe();
        }
      }
    }),
    getSocketJackpotData: builder.query({
      queryFn: async (_ref1, _api, _extraOptions, baseQuery) => {
        let {
          jackpotId,
          clientStartType
        } = _ref1;
        if (!useCloudCasinoApis) {
          const result = await baseQuery("/casino/1/gameinfo/jackpots/".concat(jackpotId.toLowerCase(), "?supplier=").concat(clientStartType));
          if (result.error) {
            return result;
          }
          return {
            data: result.data
          };
        }
        try {
          const response = await svsFetch("/v1/casino/providers/".concat(clientStartType.replace('_', '').toLowerCase(), "/jackpots/").concat(jackpotId));
          const data = await response.json();
          return {
            data
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(arg, _ref10) {
        let {
          updateCachedData,
          cacheDataLoaded,
          cacheEntryRemoved
        } = _ref10;
        const {
          jackpotId,
          clientStartType
        } = arg;
        let socketUrl;
        if (!useCloudCasinoApis) {
          socketUrl = "/casino/1/gameinfo/jackpots/".concat(jackpotId.toLowerCase(), "?supplier=").concat(clientStartType);
        } else {
          socketUrl = "/api/v1/casino/providers/".concat(clientStartType.replace('_', '').toLowerCase(), "/jackpots/").concat(jackpotId);
        }
        const handleUpdate = data => {
          if (!useCloudCasinoApis) {
            updateCachedData(() => data);
            return;
          }
          updateCachedData(() => {
            var _data$message2;
            return data === null || data === void 0 || (_data$message2 = data.message) === null || _data$message2 === void 0 ? void 0 : _data$message2.data;
          });
        };
        let subscription;
        try {
          await cacheDataLoaded; 
          if (!useCloudCasinoApis) {
            svs.core.socket.subscribe(socketUrl, handleUpdate, {}, false, true, false);
          } else {
            subscription = casinoMicroserviceSocket.subscribe(socketUrl, handleUpdate);
          }
        } catch (_unused2) {
        }
        await cacheEntryRemoved;
        if (!useCloudCasinoApis) {
          svs.core.socket.unsubscribe(socketUrl, handleUpdate);
        } else if (subscription) {
          subscription.unsubscribe();
        }
      }
    }),
    getGamesByProvider: builder.query({
      queryFn: async (_ref11, _api, _extraOptions, baseQuery) => {
        let {
          providers = [],
          count = 1000,
          offset = 0
        } = _ref11;
        const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
        if (useLegacyJupiterApi) {
          const qs = new URLSearchParams();
          qs.append('routesDomain', encodeURIComponent('spela'));
          qs.append('count', encodeURIComponent(count));
          qs.append('offset', encodeURIComponent(offset));
          const providersQuery = Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? "&providers=".concat(providers.join(',')) : '';
          const result = await baseQuery("/content/3/casinosearch?".concat(qs.toString()).concat(providersQuery));
          if (result.error) {
            return result;
          }
          return {
            data: {
              error: result.data.error,
              totalCount: result.data.totalCount,
              games: result.data.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        }

        try {
          const client = svs.content.shared.getCmsClient();
          const response = await client.v1.content.casinoSearch({
            providers: Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? providers.join(',') : undefined,
            count,
            offset
          });
          return {
            data: {
              error: null,
              totalCount: response.totalCount,
              games: response.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      }
    })
  })
});
setGlobal('svs.components.casino_react.casinoStore.endpoints.searchApi', searchApi);

 })(window);